import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

// Sentryの初期化
Sentry.init({
  dsn: 'https://491996a412ca959d125890198730e9cb@o4509262860845056.ingest.de.sentry.io/4509262869364816',
  integrations: [
    // 最新バージョンではreactインテグレーションが自動的に使用される
    // その他必要なインテグレーションがあれば追加
  ],
  // Setting this option to true will send default PII data to Sentry
  sendDefaultPii: true,
  environment: process.env.NODE_ENV,
  // エラーの10%をサンプリング (本番環境では調整可能)
  tracesSampleRate: 1.0,
  // 自動で記録するセッションの割合
  replaysSessionSampleRate: 1.0,
  // エラーがある場合は 100% の確率でセッションを記録
  replaysOnErrorSampleRate: 1.0,
  // デバッグ用に開発環境では常に有効化
  debug: process.env.NODE_ENV !== 'production',
});

// Providers and Routing first
import { AppProvider } from '@/app/providers';
import { AppRouting } from '@/app/routing';
// Shared libraries next
import { reportWebVitals } from '@/shared/lib/metrics';
import '@/app/styles/base.css';
import '@/app/styles/layout.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to.');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <BrowserRouter>
    <AppProvider>
      <AppRouting />
    </AppProvider>
  </BrowserRouter>
);

reportWebVitals();
